import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyBMc59i0QF94XA_WV2v48nB58l5Va651nA",
  authDomain: "miyazaki-quiz-comprehensive.firebaseapp.com",
  projectId: "miyazaki-quiz-comprehensive",
  storageBucket: "miyazaki-quiz-comprehensive.firebasestorage.app",
  messagingSenderId: "280206016347",
  appId: "1:280206016347:web:4a5b2fd5a83169e495247e"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
